export type IDataSetJob = {
  id: string;
  author: string;
  status: string;
  created: string;
  updated: string;
  progress: string;
  datasetId: string;
  request: {
    type:
      | 'MERGE'
      | 'PREVIEW'
      | 'APPLY_WIP'
      | 'BASIC_SHUFFLE'
      | 'DETECT_FORMAT'
      | 'PARSE_BINARIES'
      | 'VIDEO_SAMPLING'
      | 'COMBINE_UPLOAD'
      | 'UNIFORM_SHUFFLE'
      | 'ALTER_CATEGORIES'
      | 'IMPORT_ANNOTATIONS'
      | 'EXPORT_ANNOTATIONS'
      | 'USE_AS_BAYER_IMAGES';
    binaryId?: string;
    correlationId: string;
  };
  statusLog: Array<{
    time: string;
    type: string;
    message: string;
  }>;

  finished?: string;
};

export interface IJob {
  getId(): string;
  getDataSetId(): string;
  isJobFinished(): boolean;
  getRawData(): IDataSetJob;
  getAssociatedBinaryId(): string | undefined;
  getAssociatedGroupUploadedBatchId(): string;
  getJobType(): IDataSetJob['request']['type'];
}

export default class Job implements IJob {
  private _data: IDataSetJob;

  constructor(job: IDataSetJob) {
    this._data = job;
  }

  public getId() {
    return this._data.id;
  }

  public getRawData() {
    return this._data;
  }

  public isJobFinished() {
    return this._data.finished !== undefined;
  }

  public getJobType() {
    return this._data.request.type;
  }

  public getDataSetId() {
    return this._data.datasetId;
  }

  /**
   * Retrieves the ID of the group of items that were uploaded together.
   *
   * @returns {string} The ID of the group uploaded batch.
   */
  public getAssociatedGroupUploadedBatchId(): string {
    return this._data.request.correlationId;
  }

  public getAssociatedBinaryId() {
    return this._data.request.binaryId;
  }
}
